import React, { useEffect, useRef, useState } from "react";
import { useAPIs } from "../apis/APIsConfig";
import WithMainLayout from "../hocs/layouts/MainLayout";
import { getCompanies, getOffers } from "../services/ofertas";
import { useForm } from "../utils/hooks";
import Modal from "./common/Modal";

const ClubOffers = () => {
  useAPIs();

  const containerRef = useRef<any>(null);

  const [selectedCategory, setSelectedCategory] = useState<number>(1);
  const [companies, setCompanies] = useState<any[]>([]);
  const [offers, setOffers] = useState<any[]>([]);
  const [filtered, setFiltered] = useState<any[]>([]);
  const [offerTitle, setOfferTitle] = useState<string>();
  const [offerImage, setOfferImage] = useState<string>();
  const [isOpen, setIsOpen] = useState(false);
  const [formState, setError, changeHandler, reset] = useForm({
    search: "",
  });
  const categories = [
    { id: 1, class: "education", icon: "book", label: "Educación" },
    {
      id: 2,
      class: "entertainment",
      icon: "entertainment",
      label: "Entretenimiento y otros",
    },
    { id: 3, class: "beauty", icon: "beauty", label: "Belleza" },
    { id: 4, class: "health", icon: "health", label: "Salud y bienestar" },
    { id: 5, class: "hotels", icon: "hotel", label: "Hoteles y restaurantes" },
    { id: 6, class: "services", icon: "cart", label: "Servicios básicos" },
  ];

  useEffect(() => {
    document.body.classList.add("overflowHidden");
    loadCompanies(categories.filter(f => f.id === selectedCategory)[0]);
    return () => {
      // similar to componentWillUnmount() method, this function
      // would invoke at the time of component's unmount.
      document.body.classList.remove("overflowHidden");
    };
  }, []);

  useEffect(() => {
    var allData = [...companies];

    if (formState.data.search) {
      allData = [
        ...allData.filter((item) =>
          item.nombre
            .toString()
            .toLowerCase()
            .includes(formState.data.search.toLowerCase())
        ),
      ];
    }

    changeFiltered(allData);
  }, [formState.data.search]);

  function loadCompanies(category: any) {
    setSelectedCategory(category.id);
    getCompanies(category.id).then((companies) => {
      if (companies) {
        setCompanies(companies.data.value);
        changeFiltered(companies.data.value);
      }
    });

    sendColorToParent(category.class);
  }

  function sendColorToParent(clazz: string) {
    const postObj = { tabColor: getColorByClass(clazz) };
    console.info(postObj);
    window.parent.postMessage(postObj, "*");
  }

  function changeFiltered(filtered: any[]) {
    setFiltered([...filtered]);
    window.setTimeout(() => {
      const postObj = {
        width: containerRef.current?.offsetWidth,
        height: containerRef.current?.offsetHeight,
      };
      console.info(postObj);
      window.parent.postMessage(postObj, "*");
    }, 500);
  }

  function getColorByClass(clazz: string) {
    if (clazz === "education") {
      return "#1DAFE5";
    } else if (clazz === "entertainment") {
      return "#EE692D";
    } else if (clazz === "beauty") {
      return "#904092";
    } else if (clazz === "health") {
      return "#218ACA";
    } else if (clazz === "hotels") {
      return "#D71D87";
    } else if (clazz === "services") {
      return "#B6CD37";
    }
  }

  function showOffers(company: any) {
    getOffers(company.codigo).then((res) => {
      if (res) {
        setOffers(res.data.value);
        setOfferTitle(company.nombre);
        setOfferImage(company.rutaLogo);
        setIsOpen(true);
      }
    });
  }

  return (
    <section className="content-club-offers" ref={containerRef}>
      <div className="container">
        <div className="search-bar">
          <nav className="list-items-club control-tab-club">
            {categories.map((category, index) => (
              <a
                key={index}
                href="#"
                className={`tab-club ${category.class}${
                  selectedCategory === category.id ? " active" : ""
                }`}
                onClick={() => loadCompanies(category)}
              >
                <i className={`icon icon-${category.icon}`}></i>
                {category.label}
              </a>
            ))}
          </nav>
          <form>
            <div className={`form-group`}>
              <div className={`input-group`}>
                <input
                  type="text"
                  className={`form-control large`}
                  placeholder="Buscar..."
                  value={formState.data.search}
                  onChange={changeHandler("search")}
                />
                <button type="button">
                  <i className={`icon icon-search text-[16px]`}></i>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className={`content-tabs-friends`}>
          <div id="all" className={`tab-friends open`}>
            <ul className={`list-items-offers`}>
              {filtered.map((company, index) => (
                <li key={index}>
                  <a
                    onClick={() => showOffers(company)}
                    className={`card-friends-club btnOpenModalBeauty`}
                  >
                    <figure>
                      <img
                        src={company.rutaLogo}
                        alt={`Imagen ${company.nombre}`}
                      />
                    </figure>
                    <div className="description">
                      <h5>{company.nombre}</h5>
                      <span>
                        Ver detalle
                        <i className={`icon icon-arrow-right`}></i>
                      </span>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
            {/*
            <div className={`flex justify-center pt-14`}>
              <a href="javascript:;" className={`btn btn-primary btn-large`}>
                Cargar más ofertas
              </a>
            </div>
            */}
          </div>
        </div>
      </div>

      <Modal
        title={offerTitle}
        show={isOpen}
        onClose={() => setIsOpen(false)}
        image={offerImage}
      >
        <div className="description">
          <ul>
            {offers.map((offer) => (
              <li>{offer.resena}</li>
            ))}
          </ul>
        </div>
      </Modal>
    </section>
  );
};

export default WithMainLayout(ClubOffers);
